import LoginVersao from '../views/LoginVersao.vue'
import Lembrar from 'core/views/Lembrar.vue'
import Alterar from 'core/views/Alterar.vue'
import Ativar from 'core/views/Ativar.vue'
import PartnerNotFound from 'core/views/PartnerNotFound.vue'
import PartnerNotInformed from 'core/views/PartnerNotInformed.vue'
import LoginEmpresa from 'core/views/LoginEmpresa.vue'

export default [
  {
    title: 'Lista de Simulações',
    icon: 'ph-calculator-light',
    menu: true,
    path: '/simulacao',
    dir: 'views/',
    view: 'VersaoLoader',
    props: { path: 'simulador/Simulacao' },
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master']
    }
  },
  {
    title: 'Simular Proposta',
    icon: 'ph-file-plus-light',
    menu: true,
    path: '/simulacao-edit',
    dir: 'views/',
    view: 'VersaoLoader',
    props: { path: 'simulador/SimulacaoEdit' },
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master']
    }
  },
  {
    title: 'Propostas',
    menu: false,
    path: '/propostas',
    dir: 'views/',
    view: 'VersaoLoader',
    props: { path: 'proposta/PropostaEdit' },
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master']
    }
  },
  {
    title: 'Lista Propostas',
    icon: 'ph-list-checks',
    menu: true,
    home: true,
    path: '/proposta-list',
    dir: 'views/',
    view: 'VersaoLoader',
    props: { path: 'proposta/Proposta' },
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master']
    }
  },
  {
    title: 'Base de Consultas',
    icon: 'ph-hard-drives',
    menu: true,
    home: true,
    path: '/base-consultas',
    dir: 'views/',
    view: 'VersaoLoader',
    props: { path: 'base-consultas/BaseConsulta' },
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master']
    }
  },
  {
    title: 'Acesso Cliente',
    menu: false,
    home: true,
    path: '/proposta-cliente',
    dir: 'views/',
    view: 'VersaoLoader',
    props: { path: 'proposta-cliente/PropostaCliente' },
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.AcessoExterno']
    }
  },
  {
    title: 'Login Empresa',
    menu: false,
    path: '/parceiro',
    component: LoginEmpresa,
    meta: {
      anonymousAuth: true
    }
  },
  {
    title: 'Login',
    menu: false,
    path: '/partner/:parceiro',
    component: LoginVersao,
    props: { path: 'Login' },
    meta: {
      anonymousAuth: true
    }
  },
  {
    default: true,
    title: 'Lembrar Senha',
    menu: false,
    path: '/lembrar',
    component: Lembrar,
    meta: {
      anonymousAuth: true
    }
  },
  {
    default: true,
    title: 'Alterar Senha',
    menu: false,
    path: '/recuperar',
    component: Alterar,
    meta: {
      anonymousAuth: true
    }
  },
  {
    default: true,
    title: 'Ativar conta',
    menu: false,
    path: '/ativar',
    component: Ativar,
    meta: {
      anonymousAuth: true
    }
  },
  {
    title: 'Parceiro não Identificado',
    menu: false,
    path: '/partner-not-found',
    component: PartnerNotFound,
    meta: {
      anonymousAuth: true
    }
  },
  {
    title: 'PartnerNotInformed',
    menu: false,
    path: '/',
    component: PartnerNotInformed,
    meta: {
      anonymousAuth: true
    }
  }
]
